<template>
    <router-view :key="$route.fullPath"></router-view>
    <Card class="card">
        <template #title>
            Notional Distance
            <Button icon="pi pi-times" class="p-button-rounded p-button-secondary p-button-text"
                style="position:fixed;right:10px" @click="close" />
        </template>
        <template #content>
            <div class="formgrid grid">
                <div class="field col-12 md:col-3">
                    <label>NSR Label:</label>
                </div>
                <div class="field col-12 md:col-9">
                    <label>{{ zoneNSRNotionalInfo.nsrname }}</label>
                </div>
                <div class="field col-12 md:col-3">
                    <label>Building Name:</label>
                </div>
                <div class="field col-12 md:col-9">
                    <label>{{ zoneNSRNotionalInfo.buildingname }}</label>
                </div>
            </div>
            <DataTable :value="zoneNSRNotionalInfo.notionalDistances" :scrollable="true" scrollHeight="65vh"
                sortField="name" :sortOrder="1">
                <Column field="name" header="Zone" :sortable="true">
                    <template #body="slotProps">
                        <label>{{ getZoneName(slotProps.data.id) }}</label>
                    </template>
                </Column>
                <Column field="distance" header="Distance (m)" :sortable="true">
                    <template #body="slotProps">
                        <label>{{ slotProps.data.distance.toFixed(1) }}</label>
                    </template>
                </Column>
                <!-- <Column field="distancecorr" header="SWL Correction by Distance (dB(A))" :sortable="true">
                    <template #body="slotProps">
                        <label>{{ slotProps.data.distancecorr.toFixed(1) }}</label>
                    </template>
                </Column> -->
            </DataTable>
        </template>
    </Card>
</template>

<script>
import MapOL from "@/libs/myOpenLayers.js";
import { ref, reactive } from 'vue';
export default {
    data() {
        return {
            project: this.getCurrentProject(),
            zoneNSRNotionalInfo: {},
        }
    },
    computed: {
    },
    methods: {
        getCurrentProject() {
            return this.$store.getters.currentProject;
        },
        getZoneName(zoneId) {
            return this.project.zones.filter(z => z.id == zoneId)[0].name;
        },
        close() {
            this.$router.replace({ path: '/' });
        },
        getDistance(buildingid) {
            let props = this;
            this.zoneNSRNotionalInfo = MapOL.getZoneNSRNotionalInfo()[buildingid];
            this.zoneNSRNotionalInfo.notionalDistances = [];
            Object.keys(this.zoneNSRNotionalInfo).filter(key => !["closestZone", "closestDistance", "buildingid", "nsrname", "buildingname", "notionalDistances"].includes(key)).forEach(key => {
                this.zoneNSRNotionalInfo.notionalDistances.push({ id: key, distance: this.zoneNSRNotionalInfo[key].notionalDistance })
            })
            console.log(this.zoneNSRNotionalInfo);
        }
    },

    created() {
        this.getDistance(this.$route.params.buildingid);
    },
    updated() {
        this.getDistance(this.$route.params.buildingid);
    },
}
</script>

<style></style>
<style scoped>
.card {
    height: 80vh;
    width: 30vw;
    position: absolute;
    transform: translate(68vw, 2%);
}

.scrollContentPanel {
    width: 100%;
    height: calc(100vh - 270px - 4rem);
    text-align: left;
}
</style>